// extracted by mini-css-extract-plugin
export default {"bottomSection":"BottomSection_bottomSection__bQCiC"};